export enum CaslAction {
  /* General */
  Manage = "manage",
  Create = "create",
  Read = "read",
  List = "list",
  Update = "update",
  Delete = "delete",
  Restore = "restore",
  Menu = "menu",
  /* alias */
  Modify = "modify", // Update + Delete
  CRUD = "crud", // Create, Read, List, Update, Delete
  ReadAndList = "read and list", // Read, List
}
